const getDefaultState = () => ({
  loading: false,
  list: {
    items: null,
    error: null,
    brands: [],
    products: [],
    listLoading: false,
    createLoading: false,
  },
  singleLoading: false,
  single: {
    general: null,
    facilities: null,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/filter/defaultState.js